
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseFormBuilder } from 'src/app/core/formBuilders/BaseFormBuilder';



export interface SharedClaimDocumentLink {
    id: number;
    expirationDate: Date;
    createdBy: string;
    linkHash: string;
    tag: string;
    timestamp: Date;
    pinCode: string;
}

export class SharedClaimDocumentLinkFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, link: SharedClaimDocumentLink): UntypedFormGroup {
        return fb.group({
            tag: [link.tag, [Validators.required]],
            expirationDate: [this.dateValue(link.expirationDate), [Validators.required]],
            pinCode: [link.pinCode]
        });
    }

    static initSharedClaimDocumentLink(): SharedClaimDocumentLink {
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);

        return {
            id:0,
            expirationDate,
            createdBy: '',
            linkHash: '',
            tag: '',
            timestamp: new Date(),
            pinCode: ''
        };
    }
}